module.exports = __webpack_public_path__ + "img/Pescaria.adf893b0.png";